import { Component, EventEmitter, Input, Output } from '@angular/core'
import { EluxIcon } from '@elxjs/ui'

@Component({
  selector: 'app-add-button',
  standalone: true,
  imports: [EluxIcon],
  templateUrl: './add-button.component.html',
  styleUrls: ['./add-button.component.scss'],
})
export class AddButtonComponent {
  @Input() text: string = ''
  @Input() disabled: boolean = false
  @Output() onClick = new EventEmitter<void>()

  handleClick() {
    if (!this.disabled) {
      this.onClick.emit()
    }
  }
}
